<template>
    <tailwind-layout :title="maintenanceTenantProperty.property.full_address + ' Applications'">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden md:flex justify-between items-center"><!-- Block for lg and larger -->
                <h1 class="font-semibold text-2xl leading-tight">{{ maintenanceTenantProperty.property.full_address }}</h1>
                <div class="flex items-center space-x-4">
                    <inertia-link class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10" :href="route('maintenance-properties.index')">
                        <font-awesome-icon :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                    </inertia-link>
                </div>
            </div>

            <div class="px-6 lg:px-8 mx-auto flex flex-col justify-center md:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex flex-col my-4">
                    <h1 class="font-semibold text-2xl leading-tight">{{ maintenanceTenantProperty.property.full_address }}</h1>
                    <div class="flex items-center space-x-4">
                        <inertia-link class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10" :href="route('maintenance-properties.index')">
                            <font-awesome-icon :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                        </inertia-link>
                    </div>
                </div>
            </div>
        </template>

        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6 mt-3">
            <div>
                <alert-card type="info" class="mt-3">
                    <span v-if="maintenanceTenantProperty.specific_instructions">
                        {{ maintenanceTenantProperty.specific_instructions }}
                    </span>
                    <span v-else>
                        If you are experiencing any issues with this property, please submit a maintenance request by providing a clear description of the problem. Be as specific as possible to help the maintenance team resolve the issue quickly. After submitting, you will receive updates regarding the status of your request.
                    </span>
                </alert-card>

                <div class="flex justify-center space-x-4 mt-4">
                    <span class="isolate inline-flex rounded-md shadow-sm">
                        <inertia-link :href="route('maintenance-requests.create', maintenanceTenantProperty.property.id)"
                                      class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                            Request Maintenance
                        </inertia-link>
                        <inertia-link :href="route('maintenance-requests.index', maintenanceTenantProperty.property.id)"
                                      class="relative -ml-px inline-flex items-center rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 bg-white hover:bg-gray-50 ring-1 ring-inset ring-gray-300 focus:z-10">
                            <span class="ml-2">View Maintenance Requests</span>
                        </inertia-link>
                    </span>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue';
import AlertCard from "@/Shared/AlertCard.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'

export default {
    props: {
        maintenanceTenantProperty: Object,
    },
    components: {
        TailwindLayout,
        AlertCard,
        FontAwesomeIcon,
    },
    data() {
        return {
            faChevronLeft,
        }
    },
    methods: {

    }
}
</script>
